import Text from 'components/Text/Text';
import React from 'react';
import { ISubCategoryAllDishes } from 'types';
import style from './DishesScrollView.module.scss';

interface IDishesScrollView {
	data: ISubCategoryAllDishes[];
}

const DishesScrollView: React.FC<IDishesScrollView> = ({ data }) => {
	return (
		<div className={style.container} data-test="DishesScrollView">
			{data.length
				? data.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.dishName} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default DishesScrollView;
